import { useState } from "react"
import { asesoriaApi as api } from "../../api/asesoriaApi"
import { useParams } from "react-router-dom"

export const useAsesoria = (props) => {
  const [asesorias, setAsesorias] = useState([])
  const [loading, setloading] = useState(false)
  const routeParams = useParams()

  const load = async (filtros) => {
    setloading(true)
    filtros = { ...filtros }
    await api
      .load(filtros)
      .then((res) => {
        setloading(false)
        if (JSON.parse(JSON.stringify(res)).status === 200) {
          setAsesorias(res.data.data)
        } else {
          console.log(res.data.error)
        }
      })
      .catch((error) => {
        setloading(false)
        console.log(error)
      })
  }

  const onSuccess = (res, callback) => {
    setloading(false)
    // if (res.response.status === 200) {
    if (JSON.parse(JSON.stringify(res)).status === 200) {
      callback(res)
    } else {
      console.log(res.response.data.error)
      // console.log(res.data.error)
    }
  }

  const onFail = (error) => {
    setloading(false)
    console.log(error)
  }

  const handleAdministrarPromise = (responsePromise, callback) => {
    responsePromise
      .then((res) => {
        onSuccess(res, callback)
      })
      .catch((error) => {
        onFail(error)
      })
  }

  const agregarDatosAdicionalesPublicos = (payload, user) => {
    if (routeParams.hasOwnProperty("idUsuario")) {
      if (payload instanceof FormData) {
        payload.append("idUsuario", routeParams.idUsuario)
        payload.append("idProspecto", routeParams.idProspecto)
      } else {
        payload = {
          ...payload,
          idUsuario: routeParams.idUsuario,
          idProspecto: routeParams.idProspecto
        }
      }
    } else {
      payload = { ...payload }
    }
    return payload
  }

  const administrarPublicas = async (payload, callback) => {
    payload = agregarDatosAdicionalesPublicos(payload, user)
    const responsePromise = api.adminPublico(payload)
    await handleAdministrarPromise(responsePromise, callback)
  }

  const agregarDatosAdicionales = (payload, user) => {
    if (payload instanceof FormData) {
      //Si el payload es tipo FormData
      if (props.cliente) payload.append("cliente", props.cliente)
      payload.append("idUsuario", user._id)
    } else {
      payload = {
        ...payload,
        idUsuario: user._id,
        cliente: props.cliente ?? {}
      }
    }

    return payload
  }

  const administrar = async (payload, callback) => {
    setloading(true)
    const user = JSON.parse(localStorage.getItem("userData"))
    payload = agregarDatosAdicionales(payload, user)
    if (user) {
      const responsePromise = api.admin(payload)
      await handleAdministrarPromise(responsePromise, callback)
    } else {
      administrarPublicas(payload, callback)
    }
  }

  return {
    asesorias,
    loading,
    load,
    administrar
  }
}
